/* eslint-disable */
import React, { useCallback, useRef, useState } from 'react';
import StepBg from '../../../../../../assets/sme/component/step-bg.png';
import CircleActive from '../../../../../../assets/sme/component/circle-active.png';
import CircleInactive from '../../../../../../assets/sme/component/circle-inactive.png';
import ImgPoint from '../../../../../../assets/2025/arrow.gif';
import './index.less';
import './index.en.less';

export interface IIdentifyWebsiteStep {
  id?: string | number;
  label?: string;
  content?: React.ReactNode;
}

export interface IIdentifyWebsiteProps {
  title?: string;
  subTitle?: string;
  steps?: IIdentifyWebsiteStep[];
  onComplete?: () => void;
  id?: string;
}

const IdentifyWebsite: React.FunctionComponent<IIdentifyWebsiteProps> = ({
  title,
  subTitle,
  steps = [],
  onComplete,
  id,
}) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const hasCompletedRef = useRef(false);

  const handleClick = useCallback(
    (index: number) => {
      if (activeIndex >= steps.length - 1) return;
      if (index !== activeIndex + 1) return;
      setActiveIndex(() => {
        const next = index;
        if (next >= steps.length - 1 && !hasCompletedRef.current) {
          hasCompletedRef.current = true;
          setTimeout(() => onComplete?.(), 0);
        }
        return next;
      });
    },
    [activeIndex, steps.length, onComplete]
  );

  if (!steps.length) return null;

  return (
    <div className="identify-website" id={id}>
      {title && <h3 className="identify-website-title">{title}</h3>}
      {subTitle && <p className="identify-website-subtitle">{subTitle}</p>}

      <div className="identify-website-nav">
        <div className="identify-website-nav-content">
          {steps.map((step, index) => {
            const isVisible = index <= activeIndex;
            const isActive = index <= activeIndex;
            return (
              <div
                key={step.id ?? index}
                className={`identify-website-nav-step${
                  isVisible ? ' is-visible' : ''
                }`}
                style={{ '--step-index': index } as React.CSSProperties}
              >
                <div
                  className="identify-website-nav-step-text"
                  dangerouslySetInnerHTML={{ __html: step.content || '' }}
                ></div>
                <div
                  className={`identify-website-nav-step-btn${
                    isActive ? ' is-active' : ''
                  }`}
                  onClick={() => handleClick(index)}
                >
                  <div
                    className="identify-website-nav-step-btn-bg"
                    style={{
                      backgroundImage: `url(${
                        isActive ? CircleActive : CircleInactive
                      })`,
                    }}
                  />
                  <span className="identify-website-nav-step-btn-num">
                    {index + 1}
                  </span>
                  {index === activeIndex + 1 && (
                    <img
                      src={ImgPoint}
                      alt=""
                      className="identify-website-nav-step-guide"
                    />
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default React.memo(IdentifyWebsite);
